import React, { useRef, useState } from "react";
import { ImageBackground, PixelRatio, StyleSheet, View } from "react-native";
import { background, modeBarefoot, modeDarkSocks, modeBrightSocks, Icons } from "../../assets";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { useNavigation } from "@react-navigation/native";
import { Mode } from "../../shared/model/enums";
import { NewScanStateDTO } from "../../shared/model/types";
import { useGlobalState } from "../../shared/state";
import { I18N } from "../../shared/util";
import { Styles } from "../../styles";
import SelectionCard from "./SelectionCard";

const NewScanModeSelection: React.FC = (): JSX.Element => {
  const [currentScanner] = useGlobalState("currentScanner");
  const [, setState] = useGlobalState("newScanState");
  const [, setRoute] = useGlobalState("currentScreen");
  const [, setCurrentScan] = useGlobalState("currentScan");
  const [, setCurrentMeasurements] = useGlobalState("currentMeasurements");
  const [, setScanfiles] = useGlobalState("scanfiles");
  const [, setScanningDATA] = useGlobalState("scanningDATA");
  const [, setMatchedProducts] = useGlobalState("matchedProducts");
  const [, setInitialMatchedProducts] = useGlobalState("initialMatchedProducts");
  const [language] = useGlobalState("language");
  const [selectedMode, setSelectedMode] = useState<Mode | null>(null);

  const isBirkenstock = currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock";

  const i18n = I18N(language);
  const navigation = useNavigation();

  const navigate = (route: string | undefined) => {
    if (route) {
      navigation.navigate(route);
      setRoute(route);
    }
  };

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onSelect = (choice: Mode) => {
    setSelectedMode(choice);
    timeoutRef.current = setTimeout(() => {
      const route = currentScanner && currentScanner["scanner-type"] === "single" ? "ScanLeftFoot" : "ScanBothFeet";
      // const route ="ScanRightFoot";
      setState((prevState: NewScanStateDTO) => ({ ...prevState, mode: choice }));
      setCurrentScan(undefined);
      setCurrentMeasurements(undefined);
      setScanfiles([]);
      setScanningDATA(undefined);
      setMatchedProducts(undefined);
      setInitialMatchedProducts(undefined);
      navigate(route);
    }, 500);
  };

  return (
    <ImageBackground source={!isBirkenstock && background} style={Styles.backgroundImage} blurRadius={15}>
      <LayoutWrapper
        showHeaderCloseButton={false}
        showHeaderLogo={false}
        showMenuButtons={false}
        showStartButton={false}
        hideNewScanButton
        hideInfoButton
        title={i18n.t("newScan.headlines.mode")}
        showBirkenstockFooter={isBirkenstock && true}
        showBirkenstockFooterLogo={isBirkenstock && true}
        showBirkenstockHomeButton={isBirkenstock && true}
      >
        <View style={styles.contentWrapper}>
          <View style={styles.cardWrapper}>
            <SelectionCard
              value={i18n.t(`mode.${Mode.SOCKS}`).toUpperCase()}
              image={isBirkenstock ? selectedMode === Mode.SOCKS ? Icons.socksIconBirkenstock : Icons.socksIconBirkenstockDark : modeDarkSocks}
              onPress={() => onSelect(Mode.SOCKS)}
              color={isBirkenstock && selectedMode === Mode.SOCKS ? "#0B2C8F" : undefined}
              fontFamily={isBirkenstock && "Birkentype"}
              fontSize={isBirkenstock && 32}
            />
            <SelectionCard
              value={i18n.t(`mode.${Mode.BAREFOOT}`).toUpperCase()}
              image={isBirkenstock ? selectedMode === Mode.BAREFOOT ? Icons.barefootIconBirkenstock : Icons.barefootIconBirkenstockDark : modeBarefoot}
              onPress={() => onSelect(Mode.BAREFOOT)}
              color={isBirkenstock && selectedMode === Mode.BAREFOOT ? "#0B2C8F" : undefined}
              fontFamily={isBirkenstock && "Birkentype"}
              fontSize={isBirkenstock && 32}
            />
          </View>
        </View>
      </LayoutWrapper>
    </ImageBackground>
  );
};

export default NewScanModeSelection;

const styles = StyleSheet.create({
  backgroundImage: {
    resizeMode: "cover",
    flex: 1,
    backgroundColor: "white",
  },
  contentWrapper: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  cardWrapper: {
    flex: 1,
    minWidth: "60%",
    maxWidth: "70%",
    minHeight: "60%",
    maxHeight: "70%",
    marginTop: "3%",
    paddingTop: "4%",
    paddingBottom: "2%",
    paddingHorizontal: "3%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    backgroundColor: "#ffffff",
    shadowColor: "#000",
    shadowOffset: { width: 6 / PixelRatio.get(), height: 6 / PixelRatio.get() },
    shadowOpacity: 0.16,
    shadowRadius: 4 / PixelRatio.get(),
    elevation: 1,
  },
  selectionCaption: {
    fontFamily: "Montserrat-Black",
    fontSize: 21,
    color: "#3a3a3a",
    marginTop: "3.5%",
  },
});
